export default __webpack_public_path__ + "static/media/shape-top-arrow.be358c52.svg";